/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchPreviewOverlapsRequest,
  KillswitchPreviewOverlapsRequest$Outbound,
  KillswitchPreviewOverlapsRequest$outboundSchema,
} from "../components/killswitchpreviewoverlapsrequest.js";

export type KillswitchesPreviewOverlapsSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesPreviewOverlapsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  killswitchPreviewOverlapsRequest: KillswitchPreviewOverlapsRequest;
};

/** @internal */
export type KillswitchesPreviewOverlapsSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesPreviewOverlapsSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesPreviewOverlapsSecurity$Outbound,
  KillswitchesPreviewOverlapsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesPreviewOverlapsSecurityToJSON(
  killswitchesPreviewOverlapsSecurity: KillswitchesPreviewOverlapsSecurity,
): string {
  return JSON.stringify(
    KillswitchesPreviewOverlapsSecurity$outboundSchema.parse(
      killswitchesPreviewOverlapsSecurity,
    ),
  );
}

/** @internal */
export type KillswitchesPreviewOverlapsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  KillswitchPreviewOverlapsRequest: KillswitchPreviewOverlapsRequest$Outbound;
};

/** @internal */
export const KillswitchesPreviewOverlapsRequest$outboundSchema: z.ZodMiniType<
  KillswitchesPreviewOverlapsRequest$Outbound,
  KillswitchesPreviewOverlapsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    killswitchPreviewOverlapsRequest:
      KillswitchPreviewOverlapsRequest$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      killswitchPreviewOverlapsRequest: "KillswitchPreviewOverlapsRequest",
    });
  }),
);

export function killswitchesPreviewOverlapsRequestToJSON(
  killswitchesPreviewOverlapsRequest: KillswitchesPreviewOverlapsRequest,
): string {
  return JSON.stringify(
    KillswitchesPreviewOverlapsRequest$outboundSchema.parse(
      killswitchesPreviewOverlapsRequest,
    ),
  );
}
